import React from 'react'

const EyeClosedIcon = () => {
  return (
    <svg width='17' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 11.74C1 7.46525 4.46525 4 8.74 4C13.0148 4 16.48 7.46525 16.48 11.74' stroke='#878787' strokeWidth='0.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8.73979 14.5841C10.7648 14.5841 12.4063 12.9425 12.4063 10.9175C12.4063 8.89254 10.7648 7.25098 8.73979 7.25098C6.71481 7.25098 5.07324 8.89254 5.07324 10.9175C5.07324 12.9425 6.71481 14.5841 8.73979 14.5841Z' stroke='#878787' strokeWidth='0.75' strokeMiterlimit='10' />
      <path d='M2 17L17 3' stroke='#878787' strokeLinecap='round' />
    </svg>
  )
}

export default EyeClosedIcon
